<template>
  <div class="app">
    <!-- begin:: Page -->
    <HeaderBaseMobile :msg="message" />
    <div class="kt-grid kt-grid--hor kt-grid--root">
      <div
        class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page"
      >
        <AsideBase :items="nav" @close="receivedMessage($event)" />
        <div
          class="
            kt-grid__item kt-grid__item--fluid
            kt-grid kt-grid--hor
            kt-wrapper
          "
          id="kt_wrapper"
        >
          <HeaderBase @close="receivedMessage($event)" />
          <div class="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
            <SubHeaderBase :list="list" />
            <!-- begin:: Content -->
            <div
              class="kt-content kt-grid__item kt-grid__item--fluid"
              id="kt_content"
              style="position: relative"
            >
              <router-view></router-view>
            </div>
            <!-- end:: Content -->
          </div>
          <!-- begin:: Footer -->
          <FooterBase />
          <!-- end:: Footer -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderBaseMobile from "./partials/HeaderBaseMobile";
import AsideBase from "./partials/AsideBase";
import HeaderBase from "./partials/HeaderBase";
import SubHeaderBase from "./partials/SubHeaderBase";
import FooterBase from "./partials/FooterBase";
import idToRole from "../store/ui-permissions/routerPermissions";

export default {
  name: "DefaultContainer",
  components: {
    HeaderBaseMobile,
    AsideBase,
    HeaderBase,
    FooterBase,
    SubHeaderBase,
  },
  data() {
    return {
      message: "",
    };
  },
  computed: {
    nav() {
      const ret = [];
      const items = this.$store.getters["uiPermissions/navItems"];
      items.forEach((element) => {
        const tmp = JSON.parse(JSON.stringify(element));

        if (typeof element.children != "undefined") {
          element.children.forEach((el) => {
            const tmp = JSON.parse(JSON.stringify(el));
            if (typeof idToRole[tmp.id] != "undefined") {
              const role = idToRole[tmp.id];
              if (!role.ignore) {
                if (!this.$ability.can(role.action, role.subject)) {
                  return;
                }
              }
              ret.push(tmp);
            }
          });
        } else {
          if (typeof idToRole[tmp.id] != "undefined") {
            const role = idToRole[tmp.id];
            if (!role.ignore) {
              if (!this.$ability.can(role.action, role.subject)) {
                return;
              }
            }
            ret.push(tmp);
          }
        }
      });
      console.log("ret", ret);
      return ret;
    },
    name() {
      return this.$route.name;
    },
    list() {
      return this.$route.matched.filter(
        (route) => route.name || route.meta.label
      );
    },
  },
  methods: {
    receivedMessage(ev) {
      this.message = ev;
    },
  },
};
</script>

